<template>
    <div class="select-payment-type">

        <div class="adaptation-block-vertical">
            <div class="adaptation-block__double-column">
                <uzhnet-back-button @click="$router.push('/main')" />

                <div class="header-block location-center">
                    <div class="barrier">
                        <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                    </div>
                    <div class="label">
                        {{ $t('selectPaymentType.header') }}
                    </div>
                    <div class="barrier">
                        <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                    </div>
                </div>
            </div>

            <div class="adaptation-block">
                <div class="adaptation-block__column">
                    <div v-if="store.additional_services?.length > 0" class="additional-services-check" @click="$router.push('/additional-services-check')">
                        <div class="additional-services-check__title">Додаткові послуги</div>
                        <div class="additional-services-check__background">
                            <img src="@/assets/images/additional-services-check.svg" alt="">
                        </div>
                    </div>

                    <div class="subheader mt-28">
                        {{ $t('selectPaymentType.fillBalanceHeader') }}
                    </div>

                    <div @click="$router.push('/add-to-balance')" class="tariff-panel">
                        <div class="tariff-panel__background">
                            <img src="@/assets/icons/specials/tariff-panel-background.svg" alt="">
                        </div>
                        <div class="text-panel">
                            <div class="text-panel__lt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#C7C8D1" stroke-width="1"/>
                                    <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#C7C8D1" stroke-width="1"/>
                                </svg>
                            </div>
                            <div class="text-panel__lb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#C7C8D1" stroke-width="1"/>
                                    <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#C7C8D1" stroke-width="1"/>
                                </svg>
                            </div>
                            <div class="text-panel__rb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#C7C8D1" stroke-width="1"/>
                                    <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#C7C8D1" stroke-width="1"/>
                                </svg>
                            </div>
                            <div class="text-panel__rt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#C7C8D1" stroke-width="1"/>
                                    <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#C7C8D1" stroke-width="1"/>
                                </svg>
                            </div>

                            <div >

                            </div>

                            <div class="text-panel__text">
                                {{ $t('selectPaymentType.fillBalancePlate') }}
                            </div>

                        </div>
                    </div>
                </div>
                <div class="adaptation-block__column">
                    <div class="subheader mt-28 mobile-mt-80" style="color: #E0C522;">
                        {{ $t('selectPaymentType.oncePayment') }}<br><br>
                        {{ $t('selectPaymentType.or') }}<br><br>
                        {{ $t('selectPaymentType.writeOffBalance') }}
                    </div>
                    <div class="special-tariff-box">
                        <div @click="setTariffType('internet')" class="tariff-panel">
                            <div class="tariff-panel__background">
                                <img src="@/assets/icons/specials/tariff-panel-background.svg" alt="">
                            </div>
                            <div class="text-panel">
                                <div class="text-panel__lt-angle">
                                    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#E0C522" stroke-width="1"/>
                                        <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#E0C522" stroke-width="1"/>
                                    </svg>
                                </div>
                                <div class="text-panel__lb-angle">
                                    <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#E0C522" stroke-width="1"/>
                                        <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#E0C522" stroke-width="1"/>
                                    </svg>
                                </div>
                                <div class="text-panel__rb-angle">
                                    <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#E0C522" stroke-width="1"/>
                                        <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#E0C522" stroke-width="1"/>
                                    </svg>
                                </div>
                                <div class="text-panel__rt-angle">
                                    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#E0C522" stroke-width="1"/>
                                        <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#E0C522" stroke-width="1"/>
                                    </svg>
                                </div>

                                <div class="text-panel__background">

                                </div>

                                <div class="text-panel__text" style="color: #E0C522;">
                                    INTERNET
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { onMounted } from 'vue';
import { useMainStore } from '@/store/mainStore'
import { useRouter } from 'vue-router'
import ApiManager from '@/services/ApiManager'

export default {
    name: "SelectPaymentType",

    setup() {
        const store = useMainStore()
        const router = useRouter()

        const setTariffType = (type) => {
            store.setCurrentTariffType(type)
            router.push('/tariff-list')
        }

        onMounted(async () => {
            const response = await ApiManager.getAdditionalServicesCheck(store.user_id)

            const onlyPendingServices = response.data.filter(service => service.status === 'pending')
            store.setAdditionalServicesCheck(onlyPendingServices)
        })

        return {
            store,
            setTariffType
        }
    }
}
</script>
<style lang="scss">
    .mt-28 {
        margin-top: 28px;
    }

    .select-payment-type {
        padding: 0 8px;
    }

    .text-panel {
        position: relative;
        width: 75%;
        height: 45px;

        &__lt-angle {
            position: absolute;
            top: 0;
            left: 0;
        }

        &__lb-angle {
            position: absolute;
            bottom: 0;
            left: 0;
        }

        &__rb-angle {
            position: absolute;
            bottom: 0;
            right: 0;
        }

        &__rt-angle {
            position: absolute;
            top: 0;
            right: 0;
        }

        &__background {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 98.5%;
            height: 24px;
            background-color: rgba($color: #BBB, $alpha: .15);
        }

        &__text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 16px;
            margin-top: 3px;
            color: #FFF;
            font-weight: 300;
            //truncate text
            white-space: nowrap;
            text-transform: uppercase;
        }

    }

    .location-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .subheader {
        font-size: 12px;
        color: #E0C522;
        text-align: center;
    }

    .tariff-panel {
        position: relative;
        width: 100%;
        height: max-content;

        background-size: cover;
        border-radius: 10px;

        &__background {
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            border-radius: 10px;
        }

        & > .text-panel {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

    }

    @media screen and (max-width: 350px) {
        .text-panel__text {
            font-size: 14px;
        }

        .subheader {
            font-size: 10px;
        }

    }

    @media screen and (max-width: 315px) {
        .text-panel__text {
            font-size: 12px;
        }

        .subheader {
            font-size: 10px;
        }

    }

    @media screen and (max-width: 295px) {
        .text-panel__text {
            font-size: 12px;
        }

        .subheader {
            font-size: 8px;
        }

    }

    @media screen and (max-width: 280px) {
        .text-panel__text {
            font-size: 12px;
        }

        .subheader {
            font-size: 8px;
        }

    }

    @media screen and (max-width: 260px) {
        .text-panel__text {
            font-size: 12px;
        }

        .subheader {
            font-size: 8px;
        }

    }
</style>
